import { masteryLevels } from "@helpers/content/distribution";
import { useMemo } from "react";
import { useAppTheme } from "./useAppTheme";

export const useColorsFromMastery = () => {
	const theme = useAppTheme();

	const colors = useMemo(
		() =>
			masteryLevels.reduce(
				(acc, level) => {
					acc[level.id] = theme.dark ? level.darkColor : level.lightColor;
					return acc;
				},
				{} as Record<(typeof masteryLevels)[number]["id"], string>,
			),
		[theme.dark],
	);

	return colors;
};
